/// <reference path="../../typings/index.d.ts" />

import {DataStore} from './DataStore';
import {Popup} from './Popup';
import { GridAktiviteter, kontrollert } from './GridAktiviteter';
import { EditAktivitet } from './EditAktivitet';
import * as _ from "underscore";
import { Utils } from '../Utils';

export function showKopiAktiviteter(container, options, aktiviteter: GridAktiviteter) {
    new GridKopiAktiviteter(container, options, aktiviteter);
}

export class GridKopiAktiviteter {
    public grid;
    gridAktiviteter: GridAktiviteter;
    aktivitetId: number;
    planStart: Date;
    planEnd: Date;
    popup: Popup;

    constructor(container, options, aktiviteter: GridAktiviteter) {
        this.gridAktiviteter = aktiviteter;
        this.aktivitetId = options.data.id;
        var self: GridKopiAktiviteter = this;
        container.parent().removeClass('utgatt');
        container.parent().removeClass('batch');
        container.addClass("internal-grid-container p10");
        var div = $("<div class='internal-grid-caption'>").appendTo(container);
        div.append("<i class='fa fa-bars mr-5'><i>");
        div.append("Kopi Aktiviteter for " + options.data.aktivitetsItem.navn + "<span id='cntKopi" + this.aktivitetId + "' />");
        div.append("<div class='ml-20 mt--4' id='addKA" + this.aktivitetId + "'></div>");  
        div.append("<div class='ml-20 mt--4' id='btnKontrollere" + this.aktivitetId + "'></div>");                  
        var gridDiv = $('<div>')
            .addClass("internal-grid")
            .dxDataGrid({
                columnAutoWidth: false,
                dataSource: [], //DataStore.newStore("/Data/Kopiaktiviteter", { id: aktivitetId }),
                filterRow: {
                    visible: true,
                    applyFilter: "auto"
                },
                headerFilter: {
                    visible: true
                },
                selection: {
                    mode: "single"
                },
                onRowClick: (e) => {
                    e.jQueryEvent.stopPropagation();
                    var component2 = e.component, prevClickTime2 = component2.lastClickTime2;
                    component2.lastClickTime2 = new Date();
                    if (prevClickTime2 && (component2.lastClickTime2 - prevClickTime2 < 300)) {
                        e.jQueryEvent.bubbles = false;
                        e.jQueryEvent.preventDefault();
                        new EditAktivitet(e.data, e.data.planId, () => self.reloadGridData());
                    }
                },
                onRowPrepared: (info: any) => Utils.rowPrepare(info),
                noDataText: "Ingen data",
                showBorders: true,
                paging: {
                    pageSize: 20
                },
                columns: [
                    {
                        dataField: 'id',
                        caption: 'Id',
                        width: 50
                    },
                    {
                        dataField: 'aktId',
                        caption: 'AktId',
                        width: 60
                    },
                    {
                        caption: 'Kontrollert',
                        cellTemplate(container, options) {
                            if (options.data.kontrollertDato != null)
                                $(container).append("<a href='#'><span class='fa fa-check-square-o' style='font-size:15px;margin-left:6px;margin-top:0px;'></span></a>");
                        },
                        width: 50,
                        visible: true
                    },
                    {
                        caption: 'Navn',
                        dataField: 'aktivitetsItem.navn',
                        width: 300
                    }, {
                        dataField: 'dato',
                        caption: 'Produksjon',
                        dataType: 'date',
                        width: 70
                    }, {
                        dataField: 'printFil',
                        caption: 'PrintFil',
                        dataType: 'date',
                        width: 70
                    }, {
                        dataField: 'printFilOverfort',
                        caption: 'Overført',
                        dataType: 'date',
                        width: 70
                    }, {
                        dataField: 'distribusjon',
                        caption: 'Distribusjon',
                        dataType: 'date',
                        width: 70
                    }, {
                        dataField: 'forfall',
                        caption: 'Forfall',
                        dataType: 'date',
                        width: 70,
                        calculateCellValue(rowData: any) {
                            return Utils.fmtDateStr(rowData.forfall);
                        },
                    }, {
                        caption: 'Kontrollert',
                        dataField: 'kontrollertDato',
                        dataType: 'date',
                        width: 70
                    }, {
                        caption: 'Prosess',
                        dataField: 'aktivitetsItem.prosess.navn',
                        width: 70
                    }, {
                        dataField: 'produksjonsType.navn',
                        caption: 'Produksjonstype',
                        width: 70
                    }, {
                        dataField: 'fakturaGruppe.navn',
                        caption: 'FakturaGruppe',
                        width: 70
                    }, {
                        dataField: 'antallPlanlagt',
                        caption: 'Priv. planl.',
                        width: 80
                    }, {
                        dataField: 'antallProdusert',
                        caption: 'Priv. prod.',
                        width: 80
                    }, {
                        dataField: 'antalPlanlagtNaering',
                        caption: 'Nær. planl.',
                        width: 80
                    }, {
                        dataField: 'antalProdusertNaering',
                        caption: 'Nær. prod.',
                        width: 80
                    }, {
                        width: 100,
                        alignment: 'center',
                        cellTemplate: (container, options) => {
                            if (!options.data.godkjentDato) {
                                $('<a/>').addClass('dx-link')
                                    .text('Endre')
                                    .on('dxclick', () => {
                                        new EditAktivitet(options.data, options.data.planId, () => self.reloadGridData())
                                    })
                                    .appendTo(container);
                            } else {
                                $('<a/>').addClass('dx-link')
                                    .text('Endringsordre')
                                    .on('dxclick', function () {
                                        new EditAktivitet(options.data, options.data.planId, () => self.reloadGridData())

                                    })
                                    .appendTo(container);
                            }

                        }
                    },{
                        dataField: 'merknader',
                        caption: 'Merknader',
                        width: 150
                    }
                ]
            }).appendTo(container);
        var grid = gridDiv.dxDataGrid("instance");
        this.grid = grid;

        $("#addKA" + this.aktivitetId).dxButton({
            text: "Ny kopi aktivitet...",
            icon: 'add',
            type: "default",
            onClick: () => self.createKopiAktivitetForm(this.aktivitetId)
        });

        $("#btnKontrollere" + this.aktivitetId).dxButton({
            text: "Kontrollere alle aktiviteter...",
            icon: 'check',
            type: "default",
            onClick: () => {
                var self = this;
                $.post("/Data/KontrollereAlleKopiAktiviteter", { id: this.aktivitetId }, (result) => {
                    this.reloadGridData();
                });
            }
        });
        this.reloadGridData();
    }

    reloadGridData() {
        var self: GridKopiAktiviteter = this;
        $.getJSON("/Data/Kopiaktiviteter", { id: self.aktivitetId }, function (data) {
            $("#cntKopi" + self.aktivitetId).text(' (Antall:' + data.length + ', Kontrollert: ' + kontrollert(data) + ')');
            self.grid.option("dataSource", data);
            self.grid.refresh();
        });
    }

    createPopup(id:number) {
        let title = '<div class="p-header"><i class="fa fa-tasks"></i>Editere kopi aktivitet nr. ' + id.toString() + '...</div>';
        let popupContainer = $("<div>");
        $("<div>").attr("id", "form").appendTo(popupContainer);
        $("<div style=\"height:1px; border-top:1px solid silver;margin-bottom:10px;\"/>").appendTo(popupContainer);
        let buttonContainer = $("<div>").css("float", "right");
        $("<div>").attr("id", "delete").appendTo(buttonContainer);
        $("<div>").attr("id", "kontrollere").appendTo(buttonContainer);
        $("<div>").attr("id", "cancel").appendTo(buttonContainer);
        $("<div>").attr("id", "ok").appendTo(buttonContainer);
        buttonContainer.appendTo(popupContainer);
        var popupOptions = {
            width: 800,
            height: 640,
            contentTemplate: popupContainer,
            titleTemplate: title,
        };
        this.popup = new Popup(popupOptions);
    }

    lagreKopiAktivitet(kopiAktivitet: any) {
        var self = this;
        console.log(kopiAktivitet);
        var params = kopiAktivitet;
        if (kopiAktivitet.endringsAktivitetId) {
            params = {
                data: kopiAktivitet,
                endringsAktivitetId: kopiAktivitet.endringsAktivitetId
            };
        }
        $.post("/Data/Aktivitet", params)
        .done((success) => {
            DevExpress.ui.notify("Kopi aktivitet er lagret !", "success", 2000);
            self.grid.refresh();
                this.popup.hide();
            })
        .fail((xhr, textStatus, errorThrown) => {
            DevExpress.ui.notify("Kopi aktivitet er ikke lagret !", "error", 2000);
        });
    }

    AddNewKopiAktivitetPopup(id: number) {
        let title = '<div class="p-header"><i class="fa fa-tasks"></i>Legg til ny kopi aktivitet</div>';
        var self = this;
        $.get('/Plan/NewKopiAktivitetTemplate', {aktivitetId: id}, (html) => {
            var popupOptions = {
                width: 800,
                height: 570,
                contentTemplate: html,
                showTitle: true,
                titleTemplate: title,
                visible: false,
                dragEnabled: true,
                closeOnOutsideClick: false,
                showCloseButton: true
            }; 
            this.popup = new Popup(popupOptions);
            self.createKopiAktivitetForm(id);
        });
    }

    createKopiAktivitetForm(aktivitetId: any) {
        let title = '<div class="p-header"><i class="fa fa-tasks"></i>Legg til ny kopi aktivitet ...</div>';
        let container = $("<div>");
            $("<div>").attr("id", "form").appendTo(container);
            $("<div>").attr("id", "scheduler").appendTo(container);
        $("<div style=\"height:1px; border-top:1px solid silver;margin-bottom:10px;\"/>").appendTo(container);
        let buttonContainer = $("<div>").css("float", "right");
            $("<div>").attr("id", "cancel").appendTo(buttonContainer);
            $("<div>").attr("id", "ok").appendTo(buttonContainer);
        buttonContainer.appendTo(container);
        var popupOptions = {
            width: 800,
            height: 575,
            contentTemplate: container,
            titleTemplate: title,
        };
        
        this.popup = new Popup(popupOptions);
        this.popup.show();
        var self = this;
        $.get("/Data/Aktivitet", { id: aktivitetId })
            .done((aktivitet) => {
                $.get("/Data/GetPlanInfo", { planId: aktivitet.planId }, (data) => {
                    self.planStart = data.start;
                    self.planEnd = data.stop;
                    var fra = new Date(aktivitet.dato.toString());
                    var til = new Date(self.planEnd.toString());
                    til.setHours(23, 59, 59);
                    var formData = {
                        fra,
                        til,
                        priority: 0
                    }
                    var col1 = [
                        {
                            dataField: "fra",
                            label: { text: "Fra" },
                            editorType: "dxDateBox",
                            editorOptions: {
                                min: this.planStart,
                                max: this.planEnd,
                                width: "100%",
                                displayFormat: 'dd.MM.yyyy'
                            }
                        }, {
                            dataField: "til",
                            label: { text: "Til" },
                            editorType: "dxDateBox",
                            editorOptions: {
                                min: this.planStart,
                                max: this.planEnd,
                                width: "100%",
                                displayFormat: 'dd.MM.yyyy'
                            }
                        }
                    ];
                    var col2 = [
                        {
                            dataField: "count",
                            label: { text: "Hopp over" },
                            editorType: "dxNumberBox",
                            editorOptions: {
                                width: "100%",
                                value: 1,
                                min: 1,
                                max: 30,
                                showSpinButtons: true
                            }
                        }, {
                            dataField: "type",
                            editorType: "dxSelectBox",
                            editorOptions: {
                                width: "100%",
                                items: ['Dager', 'Uker', 'Måneder'],
                                value: 'Dager'
                            }
                        }
                    ];
                    var col3 = [
                        {
                            editorType: "dxButton",
                            editorOptions: {
                                text: "Generere",
                                type: "default",
                                icon: 'save',
                                width: 200,
                                onClick: function () {
                                    var fra = form.option("formData").fra;
                                    var til = form.option("formData").til;
                                    var cnt = form.option("formData").count;
                                    var typ = form.option("formData").type;
                                    let arr = [];
                                    //debugger;
                                    var red_days = Utils.getRedDays();
                                    red_days.forEach((day) => {
                                        arr.push({
                                            startDate: day,
                                            endDate: day,
                                            text: "",
                                            allDay: true,
                                            ownerId: [1]
                                        });
                                    });
                                    function handleDate(date, max):Date {
                                        var dato = new Date(date);
                                        while (Utils.isInvalidDate(dato))
                                            dato.setDate(dato.getDate() + 1);
                                        date = dato;
                                        let endDate = new Date(dato.getTime());
                                        endDate.setHours(21, 59, 59);
                                        if (dato <= max) {
                                            arr.push({
                                                startDate: dato, 
                                                endDate: endDate,
                                                text: "",
                                                allDay: true,
                                                ownerId: [2]
                                            });
                                        }
                                        return new Date(dato);
                                    }
                                    function numberOfDays(year, month) {
                                        var d = new Date(year, month, 0);
                                        return d.getDate();
                                    }
                                    switch (typ) {
                                        case "Dager": {
                                            let date = new Date(fra);
                                            while (date <= til) {
                                                date = handleDate(date, til);
                                                date.setDate(date.getDate() + cnt);
                                            }
                                            break;
                                        }
                                        case "Uker": {
                                            let date = new Date(fra);
                                            while (date <= til) {
                                                handleDate(date, til);
                                                let newDate = new Date(date.getTime());
                                                newDate.setDate(date.getDate() + cnt * 7);
                                                date = newDate;
                                            }
                                            break;
                                        }
                                        case "Måneder": {
                                            let date = new Date(fra);
                                            let fraDays = new Date(fra).getDate();
                                            while (date <= til) {
                                                handleDate(date, til);
                                                let newDate = new Date(date.getTime());
                                                if (numberOfDays(date.getFullYear(), date.getMonth() + 1) < fraDays) {
                                                    //Jump over one month if the days in that month are greater than the date of fra
                                                    newDate.setMonth(date.getMonth() + cnt * 2);
                                                } else {
                                                    newDate.setMonth(date.getMonth() + cnt);
                                                    newDate.setDate(fraDays);
                                                }
                                                date = newDate;
                                            }
                                            break;
                                        }
                                    }
                                    scheduler.option("dataSource", arr);
                                }
                            }
                        }, {
                            editorType: "dxButton",
                            editorOptions: {
                                text: "Clear",
                                icon: 'close',
                                width: 200,
                                onClick: function () {
                                    scheduler.option("dataSource", []);
                                }
                            }
                        }
                    ];

                    var c1 = [{
                        itemType: "group",
                        items: col1
                    }, {
                        itemType: "group",
                        items: col2
                    }, {
                        itemType: "group",
                        items: col3
                    }];

                    var form = $("#form").dxForm({
                        colCount: 4,
                        formData: formData,
                        items: c1
                    }).dxForm("instance");

                    var resourcesData = [
                        {
                            id: 1,
                            text: "Helgedag",
                            color: "red"
                        }, {
                            text: "John Heart",
                            id: 2,
                            color: "#56ca85"
                        }, {
                            text: "Todd Hoffman",
                            id: 3,
                            color: "#1e90ff"
                        }, {
                            text: "Sandra Johnson",
                            id: 4,
                            color: "#ff9747"
                        }
                    ];

                    var scheduler = $("#scheduler").dxScheduler({
                        dataSource: [],
                        views: ["month"],
                        currentView: "month",
                        currentDate: new Date(aktivitet.dato),
                        useDropDownViewSwitcher: false,
                        firstDayOfWeek: 0,
                        startDayHour: 6,
                        endDayHour: 17,
                        resources: [{
                            field: "ownerId",
                            allowMultiple: true,
                            dataSource: resourcesData,
                            label: "Owner"
                        }],
                        width: "100%",
                        height: 400
                    }).dxScheduler("instance");

                    $("#cancel").dxButton({
                        text: "Avbryt",
                        height: 30,
                        width: 200,
                        icon: 'close',
                        onClick: () => {
                            self.popup.hide();
                        }
                    });


                    $("#ok").dxButton({
                        text: "Lagre",
                        type: "success",
                        icon: 'save',
                        height: 30,
                        width: 200,
                        onClick: function () {
                            let data = scheduler.option("dataSource");
                            let weekDays = _.filter(data, (itm: any) => {
                                let isHoliday: boolean = _.contains(itm.ownerId, 1);
                                return !isHoliday;
                            });
                            let startDates = weekDays.map(r => r.startDate.toUTCString());
                            //console.log(startDates, aktivitet);
                            let ffdager = self.gridAktiviteter.forfallsDager;
                            $.post("/Data/AddKopiAktiviteter", { aktivitet, dates: startDates, forfallsDager: ffdager })
                                .done(() => {
                                    DevExpress.ui.notify("KopiAktivitet lagret!", "success", 2000);
                                    self.reloadGridData();
                                    self.popup.hide();
                                })
                                .fail(() => {
                                    DevExpress.ui.notify("KopiAktivitet ikke lagret!", "error", 2000);
                                });
                        }
                    });

                });
            });
    }
}






// WEBPACK FOOTER //
// ./TS/Plan/GridKopiAktiviteter.ts